import React, { Component } from 'react';
import { connect } from 'react-redux';
import { flatten, get, values } from 'lodash';

import ShareSummary, { TOTAL_PURCHASE } from '../../../components/share-summary';

import {
  getCurrentPurchase,
  getOrganizerMembership,
  getCommittedMemberships,
} from '../../../selectors/purchase-selector';
import { AUTOPILOT_NAMESPACE, activateTab } from '../../../actions';
import money, { Money } from '../../../lib/money';

class ShareSummaryContainer extends Component {
  constructor(props) {
    super(props);
    this.setView = this.setView.bind(this);
  }

  get committedInvitees() {
    return this.props.committedInvitees || [];
  }

  get inviteesShareAmount() {
    const amounts = this.committedInvitees.map(i => money(i.shareAmount));
    return Money.sum(amounts);
  }

  get payments() {
    return get(this.props, 'purchase.payments', []);
  }

  get contributionsShareAmount() {
    const { currentPaymentId } = this.props;
    const contributions = flatten(this.committedInvitees
      .map(invitee => invitee.contributions))
      .filter(contribution => contribution.paymentId === currentPaymentId)
      .map(contribution => money(contribution.shareAmount));

    return Money.sum(contributions);
  }

  get inviteesSize() {
    const availableSlots = this.props.autoPilotTriggerSlots - this.props.committedSlots;
    return availableSlots + this.props.invitees.length;
  }

  setView(view) {
    this.props.activateTab(view);
  }

  render() {
    if (!this.props.purchase.id) return null;
    return (
      <ShareSummary
        title="Expected group breakdown"
        organizerTotalShareAmount={this.props.organizerTotalShareAmount}
        organizerCurrentShareAmount={this.props.organizerCurrentShareAmount}
        inviteesShareAmount={this.inviteesShareAmount}
        contributionsShareAmount={this.contributionsShareAmount}
        inviteesSize={this.inviteesSize}
        payments={this.props.payments}
        currencyCode={this.props.currencyCode}
        view={this.props.activeTab}
        onViewToggle={this.setView}
        namespace={AUTOPILOT_NAMESPACE}
        showPaymentSchedule
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { projections } = state;
  const currentPurchase = getCurrentPurchase(state);
  const projectedPurchase = get(projections, `${AUTOPILOT_NAMESPACE}.purchase`, {});
  const organizerMembership = getOrganizerMembership(state);
  const { currentPayment, currencyCode } = currentPurchase;
  const invitees = getCommittedMemberships(state).filter(m => m.id !== organizerMembership.id);
  const activeTab = state.ui.activeTab || TOTAL_PURCHASE;
  const props = {
    payments: currentPurchase.payments,
    committedSlots: currentPurchase.committedSlots,
    invitees,
    organizerMembership,
    activeTab,
    purchase: projectedPurchase,
    currencyCode,
  };

  if (!organizerMembership) return props; // TODO: show not-committed version

  const projectedOrgMembership = get(projections,
    `${AUTOPILOT_NAMESPACE}.memberships.${organizerMembership.id}`, {
      shareAmount: Money.zero(currentPurchase.currencyCode),
      contributions: [],
    });

  const organizerTotalShareAmount = projectedOrgMembership.shareAmount;
  const currentContribution = projectedOrgMembership.contributions.filter((c) => {
    return c.paymentId === currentPayment.id;
  })[0];
  let organizerCurrentShareAmount = Money.zero(currencyCode);

  if (currentContribution) {
    organizerCurrentShareAmount = currentContribution.shareAmount;
  }

  const projectedMemberships = values(get(projections, `${AUTOPILOT_NAMESPACE}.memberships`), {});
  const projectedInvitees = projectedMemberships.filter(m => m.id !== organizerMembership.id);

  const autoPilotTriggerSlots = ownProps.autoPilotTriggerSlots;

  return {
    ...props,
    currentPaymentId: currentPayment.id,
    organizerTotalShareAmount,
    committedInvitees: projectedInvitees,
    organizerCurrentShareAmount,
    autoPilotTriggerSlots,
  };
};

const mapDispatchToProps = {
  activateTab,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareSummaryContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/autopilot/share-summary.container.js